import React from 'react';
import { NavLink, useRouteMatch } from 'react-router-dom';

const NavItem = ({ route }) => {
  const match = useRouteMatch({ path: route.link, exact: true });
  const isActive = !!match;
  return (
    <NavLink
      to={route.link}
      key={route.link}
      className={`text-[13px] relative flex items-center gap-[10px] rounded-[8px] py-2.5 px-[11px] w-full transition-all duration-200 ease-in-out cursor-pointer ${
        isActive
          ? 'font-medium bg-[#004D4D] text-white'
          : 'font-normal text-[#FFFFFF8C]'
      }`}
    >
      {isActive && (
        <div className="absolute left-0 h-[18px] bg-[#5DCAA5] rounded-r-[2px] w-[3px]" />
      )}
      {isActive ? route.iconActive : route.icon}
      {route.name}
    </NavLink>
  );
};

export default NavItem;
